import React from 'react'
import qr from "../../../assets/Download_QR.png";
const DownloadApp = () => {
  return (
    <section className="w-full bg-gradient-to-r from-[#e6f0ff] to-[#f3e8ff] py-12 px-4">
  <div className="mx-auto max-w-5xl text-center rounded-xl px-6 py-10">

    <h2 className="text-lg font-semibold text-gray-800 mb-2">
      Think Logistics, Think Porter!
    </h2>

    <p className="text-sm text-gray-600 mb-6">
      Get the Porter mobile app to start booking your orders!
    </p>

    {/* QR CODE */}
    <div className="flex justify-center">
      <div className="bg-white p-3 rounded-lg shadow-sm">
        <img
          src={qr}
          alt="QR Code"
          className="w-[110px] h-[110px] object-contain"
        />
      </div>
    </div>

    <p className="text-xs text-gray-500 mt-3">
      Scan to download our app!
    </p>

  </div>
</section>
  )
}

export default DownloadApp
